require('lang');

require("css/global.css");
require("highlight.css");
require("css/articleAOF.css");
require("fonts.css");
require("css/articleAOF.css");
require("js/highlightjs/styles/base16/tomorrow.min.css");
require("js/recogito/recogito.min.css");



require('script-loader!js/jquery_1.11.2.js');
require('script-loader!js/aof.js');
require('script-loader!js/highlightjs/highlight.min.js');

require('script-loader!js/article_formulas.js');
require('script-loader!js/recogito/recogito.min.js');

